/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-08 16:09:35
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-08 17:02:11
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Line/index.ts
 */
import type {
  LineBasicMaterialParameters, LineDashedMaterialParameters,
  SceneControl,
  Line as TLine,
} from '@anov/3d-core'
import {
  BufferGeometry,
  LineBasicMaterial,
  LineDashedMaterial,
  Line as ThreeLine,
  Vector3,
} from '@anov/3d-core'
import ObjectLayer from '../Base/ObjectLayer'
import type { options } from './types'
import type { ILine } from './interface'

export class Line extends ObjectLayer implements ILine {
  private line: TLine

  constructor(options: options, sceneControl: SceneControl) {
    super(sceneControl)
    this.line = this.createLine(options)
    this.add(this.line) // 挂载到 ObjectLayer 中
  }

  public createLine(options: options): TLine {
    const { points, dashed = false, material = {} } = options
    const vecPoints = points.map(p =>
      Array.isArray(p) ? new Vector3(...p) : p,
    )
    const geometry = new BufferGeometry().setFromPoints(vecPoints)
    // 默认参数
    const defaultBasic: LineBasicMaterialParameters = {
      color: 0xFFFFFF,
      linewidth: 1,
      linecap: 'round',
      linejoin: 'round',
      opacity: 1,
      transparent: false,
      visible: true,
      depthTest: true,
      depthWrite: true,
    }

    const defaultDashed: LineDashedMaterialParameters = {
      ...defaultBasic,
      scale: 1,
      dashSize: 3,
      gapSize: 1,
    }

    const mat = dashed
      ? new LineDashedMaterial({ ...defaultDashed, ...material })
      : new LineBasicMaterial({ ...defaultBasic, ...material })

    const line = new ThreeLine(geometry, mat)

    if (dashed)
      line.computeLineDistances()

    return line
  }

  /** 更新线条 */
  public updateLine(options: options) {
    if (this.line) {
      this.remove(this.line)
      this.line.geometry.dispose()
      ; (this.line.material as any).dispose()
    }
    this.line = this.createLine(options)
    this.add(this.line)
  }

  /** 销毁释放资源 */
  public destroy() {
    if (!this.line)
      return
    this.remove(this.line)
    this.line.geometry.dispose()
    ; (this.line.material as any).dispose()
    // @ts-ignore
    this.line = null
  }
}
